import type { FaireProductEntity } from "../../entity_types/product";

export const p_495tk8rjga: FaireProductEntity = {
  token: "p_495tk8rjga",
  type: "product",
  name: "Leopard Knotted Gown",
  brandToken: "b_3pci2bfmjr",
  brandName: "Three Little Tots",
  imageUrl:
    "https://cdn.faire.com/fastly/82f47da3450e241588ec107bb3aebb9b8ae5c11025533c764e64fffc3319438a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/1b9f6489a2165e69a8bdb69cf4757a9e1dad073723745c0c5be7065b6e63a208.jpeg",
    "https://cdn.faire.com/fastly/597081f05dd2b6ee5a40f9c7203b103b42cb20c0219d5465514cdf4c43203efc.jpeg",
    "https://cdn.faire.com/fastly/9c39f0356423976c4610fed9aec728c03125ab115797e93757def69b2bb770bb.jpeg",
    "https://cdn.faire.com/fastly/f54c9c513dd0a06284714e0fd581c6e120c6cd6b27448ab543bf834a6c7940b0.jpeg",
    "https://cdn.faire.com/fastly/27904e3206a09e3ac78e806b7e00b16ba49a9ad3fa96faadb33fd5d819a8c36d.jpeg",
    "https://cdn.faire.com/fastly/a40e6875bb6753fa0754880e2a2e677295acd470fb00a96ce95f030f537abb25.jpeg",
    "https://cdn.faire.com/fastly/26ed695c28e702e292ff47ec5a5e89b1a8ab946d2f4ad2caedba6a89c5c98199.jpeg",
    "https://cdn.faire.com/fastly/8311519fe5eddce2835a2fdea371ac8dfa61432e6c8c12b34688c476bb06a5df.jpeg",
    "https://cdn.faire.com/fastly/a2c98bf1a5237e62c3df28f99841f877de6b213f28557aa7fa4e26e79d5a24c4.jpeg",
    "https://cdn.faire.com/fastly/72a313a81bfc769ab31037eab5baa07947bd2d25fb8bc9a0b0f566a4452d67bc.jpeg",
    "https://cdn.faire.com/fastly/2e1e3271a98a43770d13c04b4a8e9103be275d4a5f78b724787d0e470c55fa60.jpeg",
    "https://cdn.faire.com/fastly/1de64bc92d5994c4d88646ed6fbbeac819d4213addc962a9fe2c71ee95158c8e.jpeg",
    "https://cdn.faire.com/fastly/b603d8631ad2938a3459a45e4834fd9c96797f1101f9bd17183a7aaf00f01a23.jpeg",
    "https://cdn.faire.com/fastly/295770e97be2d29fc8661ac9db2a6a7223a9820d08afec2b9ff8dce028f3618e.jpeg",
    "https://cdn.faire.com/fastly/f1a079c85c009cff42cc59f71b8ff0f552785d1a66789ac484839fc7bb2eae5c.jpeg",
    "https://cdn.faire.com/fastly/bac78d37dff7daeb223c4c5cc6c45ee237ccd075589bbe35c2dc8bdd864669d4.jpeg",
    "https://cdn.faire.com/fastly/5c5c1845f493f0f5b80c37096d99fa9cbbdd1e4c5ceb21ab8341ef83211215b7.jpeg",
    "https://cdn.faire.com/fastly/9e0455fc73b44cd2389ceaa7d58131b98a088c1e3f4b2b67093410b8719f86a5.jpeg",
    "https://cdn.faire.com/fastly/a1fc71f9ebf549c6f719c7d2840dfc3df50461684184ab74d2badc15bca3cf32.jpeg",
    "https://cdn.faire.com/fastly/e7c6063907f6d1e85c1751e1aa6e41709603b9f7368deca529c7689fd690dc37.jpeg",
    "https://cdn.faire.com/fastly/7caad18b3f1c9cd25c5b849505ed80311459a374756952d8e97aa17a47df65ac.jpeg",
    "https://cdn.faire.com/fastly/083339fc74acd5b447dc5cf8db692bd76d7d20c0d6233ced9ee10ef5358eeede.jpeg",
    "https://cdn.faire.com/fastly/16817f7f96296de975093acf2b27fa6853f2b2ea0a6b33cbec3ea32f822155e4.jpeg",
  ],
  priceDollars: 11.3,
  description:
    "These baby gowns are so soft you will never want your baby in anything else. Fabric is designed to be soft, comfortable, and stretchy. The tie bottom allows for easy night-time diaper change. The pull down tabs on the shoulder makes it easy to dress and change. Newborn-3 month fits approx 5lbs-15lbs.\n",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:08.306Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
